(function () {
  'use strict';
  const dialog = document.querySelector('#occ-cart-editor');
  if (!dialog || !dialog.showModal || !window.OCCCartVariantCore || window.OCCCartEditor) return;
  window.OCCCartEditor = true;
  const core = OCCCartVariantCore.create({root: window.Shopify?.routes?.root || dialog.dataset.root || '/'});
  const find = part => dialog.querySelector('[data-occ-cart-edit-' + part + ']');
  const status = find('status'), select = find('option'), apply = find('apply'), close = find('close'), review = find('review');
  let trigger, snapshot, generation = 0, loading = false, mustReview = false;
  const money = cents => {
    if (!Number.isFinite(cents)) return 'Price available on the product page';
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', {style: 'currency', currency: window.Shopify?.currency?.active || dialog.dataset.currency || 'ZAR'}).format(cents / 100); }
    catch (_) { return 'Price available on the product page'; }
  };
  function say(text, error = false) { status.textContent = text; status.dataset.error = String(error); }
  function showControls() { document.querySelectorAll('[data-occ-cart-edit]').forEach(button => { button.hidden = false; }); }
  function optionChanged() {
    const option = snapshot?.product.variants.find(v => String(v.id) === select.value);
    apply.disabled = !option?.available || String(snapshot?.item.variant_id) === select.value;
    find('price').textContent = option ? 'Option price: ' + money(option.price) + ' each, before cart-level discounts.' : '';
  }
  function leave() {
    if (core.busy()) { say('The store is updating your option. Please wait.'); return; }
    if (mustReview) { location.assign(review.href); return; }
    ++generation; dialog.close(); trigger?.focus();
  }
  async function load() {
    const seq = ++generation; loading = true; snapshot = null;
    find('fields').hidden = apply.hidden = find('retry').hidden = true;
    find('product').textContent = find('current').textContent = '';
    say('Loading the latest cart and product options…');
    try {
      const result = await core.inspect(trigger.dataset.key, trigger.dataset.handle);
      if (seq !== generation || !dialog.open) return;
      if (String(result.item.product_id) === dialog.dataset.giftProduct || String(result.item.variant_id) === dialog.dataset.protectionVariant) {
        throw new Error('This item is tied to a gift or protection service. Use its original product flow.');
      }
      snapshot = result;
      find('product').textContent = result.product.title;
      find('current').textContent = 'Currently: ' + (result.item.variant_title || 'Default option') + ' · Quantity ' + result.item.quantity;
      select.replaceChildren();
      result.product.variants.forEach(variant => {
        const option = document.createElement('option'); option.value = String(variant.id);
        option.textContent = variant.title + (variant.available ? '' : ' — unavailable'); option.disabled = !variant.available;
        select.appendChild(option);
      });
      select.value = String(result.item.variant_id);
      find('fields').hidden = apply.hidden = false;
      say(result.product.variants.length >= 250 ? 'More options may be available on the product page.' : 'Choose an available option, then select Update option.');
      optionChanged(); select.focus();
    } catch (error) {
      if (seq !== generation || !dialog.open) return;
      say(error.message, true); find('retry').hidden = !['network', 'platform'].includes(error.code);
    } finally { if (seq === generation) loading = false; }
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-occ-cart-edit]');
    if (!button) return;
    event.preventDefault();
    if (dialog.open) return;
    trigger = button; mustReview = core.needsReview(); close.textContent = 'Cancel'; close.hidden = false; review.hidden = true;
    find('product-link').hidden = false;
    const base = window.Shopify?.routes?.root || dialog.dataset.root || '/';
    find('product-link').href = base + 'products/' + encodeURIComponent(button.dataset.handle);
    dialog.showModal();
    if (window.occCartMutationBusy || mustReview) {
      find('fields').hidden = apply.hidden = find('retry').hidden = true;
      say(mustReview ? 'Review the latest cart before editing another item.' : 'Another cart update is running. Wait for it to finish, then open this editor again.', true);
      review.hidden = !mustReview;
      return;
    }
    load();
  });
  apply.addEventListener('click', async () => {
    if (!snapshot || loading || apply.disabled || core.busy()) return;
    apply.disabled = close.disabled = true; select.disabled = true; find('product-link').hidden = true;
    say('Updating your option. Please wait while the store confirms the cart…');
    try {
      const result = await core.replace(snapshot.item, select.value, trigger.dataset.handle);
      if (result.changed) {
        mustReview = true;
        say('Changed to ' + result.option.title + '. Quantity ' + snapshot.item.quantity + ' kept. Review your updated cart for recalculated totals.');
      }
    } catch (error) {
      mustReview = error.review || core.needsReview(); say(error.message, true);
    } finally {
      close.disabled = select.disabled = false;
      if (mustReview) {
        find('fields').hidden = apply.hidden = close.hidden = true; review.hidden = false; review.focus();
      } else { find('product-link').hidden = false; optionChanged(); }
    }
  });
  find('retry').addEventListener('click', load);
  close.addEventListener('click', leave);
  select.addEventListener('change', optionChanged);
  dialog.addEventListener('cancel', event => { event.preventDefault(); leave(); });
  // Actual section rerenders create new buttons; delegation keeps behaviour single-bound.
  let scheduled = false;
  const observer = new MutationObserver(() => {
    if (scheduled) return; scheduled = true;
    requestAnimationFrame(() => { scheduled = false; showControls(); });
  });
  observer.observe(document.body, {childList: true, subtree: true}); showControls();
})();
